import { clsx, ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Merge Tailwind class names safely
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Format a date to 'en-IN' locale
 */
export const formatDate = (date: string | Date): string => {
  return new Date(date).toLocaleDateString("en-IN")
}

/**
 * Truncate a string to `n` characters and add ellipsis
 */
export const truncate = (str: string | undefined, n: number): string | undefined => {
  return str && str.length > n ? str.slice(0, n) + "..." : str
}
